import React from 'react';
import { toClasses } from 'class-converter';
import { ChildrenSrcEspece } from 'mpm-classes/DeclarationVente';
import Components from 'mpm-components';
import Utilities from 'mpm-config/Utilities';
import Services from 'mpm-services';

import NumberFormat from 'react-number-format';
import { DateInput } from 'semantic-ui-calendar-react';
import { Button, Form } from 'semantic-ui-react';

export default ({ declarationVente, setDeclarationVente, setMessage }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    if (declarationVente.id && declarationVente.existingChildrenSrcEspeceDV.length === 0) {
      onFetchDeclarationCapture(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFetchDeclarationCapture = (e) => {
    e && e.preventDefault();
    if (declarationVente.numeroDC && declarationVente.numeroDC.length > 0) {
      setIsLoading(true);
      setTimeout(() => {
        Services.DeclarationVenteService.findDC(declarationVente.numeroDC)
          .then((result) => {
            if (result.success) {
              prepareData(result.data);
            } else {
              setMessage({
                warning: true,
                header: 'Recherche',
                content: result.message,
              });
              //prepareData(result.data);
            }
            setTimeout(() => {
              setIsLoading(false);
            }, 200);
          })
          .catch((err) => {
            setDeclarationVente({ ...declarationVente, existingChildrenSrcEspeceDV: [] });
            setTimeout(() => {
              setIsLoading(false);
            }, 200);
          });
      }, 2000);
    }
  };
  const prepareData = (data) => {
    const existingOnes = toClasses([...data.childrenSrcEspeceDV], ChildrenSrcEspece);
    // .map((item) => {
    //   const totalQuantite = Array.from(declarationVente.childrenSrcEspeceDV)
    //     .filter((elm) => elm.refEspece?.id === item.refEspece?.id)
    //     .map((elm) => {
    //       return elm.quantite ? elm.quantite : 0;
    //     })
    //     .reduce((acc, cur) => acc + (cur || 0), 0);
    //   item.poidsADebarqueEstime -= totalQuantite;
    //   return item;
    // });
    if (declarationVente.id) {
      setDeclarationVente({ ...declarationVente, id_refDeclaration: data.id_refDeclaration, existingChildrenSrcEspeceDV: existingOnes });
    } else {
      setDeclarationVente({ ...declarationVente, id_refDeclaration: data.id_refDeclaration, childrenSrcEspeceDV: [], existingChildrenSrcEspeceDV: existingOnes });
    }
  };

  const onChangeData = (name, value) => {
    if (name === 'numeroDV' && name !== '' && !Utilities.isNumber(value)) return;
    if (name === 'numeroDC') {
      setDeclarationVente({ ...declarationVente, childrenSrcEspeceDV: [], existingexistingChildrenSrcEspeceDV: [] });
    }
    setDeclarationVente({ ...declarationVente, [name]: value });
  };

  return (
    <Components.Regions.RegionWithHeader title="label.declaration.vente" formatted headerColor="blue" headerSize="small">
      <Form>
        <Form.Group widths="equal">
          <Form.Input label="Référence Déclaration de vente" value={declarationVente.numeroDV} disabled />
          <DateInput label="Date Système " value={declarationVente.dateDeclaration} onChange={() => undefined} name="dateDeclaration" icon="calendar" iconPosition="right" dateFormat="DD/MM/YYYY" disabled />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input disabled={declarationVente?.existingChildrenSrcEspeceDV?.length > 0} label="Numéro Visa" name="numeroDC" value={declarationVente.numeroDC} onChange={(evt, { name, value }) => onChangeData(name, value)} action={<Button disabled={!declarationVente.numeroDC} icon="search" loading={isLoading} onClick={(e) => onFetchDeclarationCapture(e)} />} />
          <Form.Field />
        </Form.Group>
        <Components.Regions.RegionWithHeader title="label.especes" headerColor="blue" headerSize="small" loading={isLoading} className="scrolling-x">
          {!isLoading && (
            <Components.Tables.SmartTable
              header={[
                {
                  selector: 'refEspece.libelle',
                  textAlign: 'center',
                  label: 'Espece',
                },
                {
                  selector: 'poidsADebarqueEstime',
                  textAlign: 'center',
                  label: 'Disponible en KG',
                  component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.poidsADebarqueEstime} />,
                },
              ]}
              data={declarationVente.existingChildrenSrcEspeceDV || []}
              grouped={false}
              pagination={true}
              striped={true}
              sortable={true}
              rowsPerPage={10}
            />
          )}
        </Components.Regions.RegionWithHeader>
      </Form>
    </Components.Regions.RegionWithHeader>
  );
};
